import { render } from "./indexcomptable.vue?vue&type=template&id=56fe9fb6&scoped=true"
import script from "./indexcomptable.vue?vue&type=script&lang=js"
export * from "./indexcomptable.vue?vue&type=script&lang=js"

import "./indexcomptable.vue?vue&type=style&index=0&id=56fe9fb6&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56fe9fb6"]])

export default __exports__